"use strict";

var _slicedToArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readSInt64 = exports.readSInt32 = exports.readUInt64 = exports.readUInt32 = exports.writeSInt64 = exports.writeUInt64 = exports.writeSInt32 = exports.writeUInt32 = void 0;
var msg = 0x80;
var rest = 0x7f;

var writeUInt32 = function writeUInt32(value) {
  var result = [];
  var index = 0;

  while (value > rest) {
    result[index] = msg | (value & rest) >>> 0;
    value = value >>> 7 >>> 0;
    index += 1;
  }

  result[index] = value;
  return Buffer.from(result);
};

exports.writeUInt32 = writeUInt32;

var writeSInt32 = function writeSInt32(value) {
  if (value >= 0) {
    return exports.writeUInt32(2 * value);
  }

  return exports.writeUInt32(-2 * value - 1);
};

exports.writeSInt32 = writeSInt32;

var writeUInt64 = function writeUInt64(value) {
  var result = [];
  var index = 0;

  while (value > BigInt(rest)) {
    result[index] = Number(BigInt(msg) | value & BigInt(rest));
    value >>= BigInt(7);
    index += 1;
  }

  result[Number(index)] = Number(value);
  return Buffer.from(result);
};

exports.writeUInt64 = writeUInt64;

var writeSInt64 = function writeSInt64(value) {
  if (value >= BigInt(0)) {
    return exports.writeUInt64(BigInt(2) * value);
  }

  return exports.writeUInt64(BigInt(-2) * value - BigInt(1));
};

exports.writeSInt64 = writeSInt64;

var readUInt32 = function readUInt32(buffer, offset) {
  var result = 0;
  var index = offset;

  for (var shift = 0; shift < 32; shift += 7) {
    if (index >= buffer.length) {
      throw new Error('Invalid buffer length');
    }

    var bit = buffer[index];
    index += 1;

    if (index === offset + 5 && bit > 0x0f) {
      throw new Error('Value out of range of uint32');
    }

    result = (result | (bit & rest) << shift) >>> 0;

    if ((bit & msg) === 0) {
      return [result, index - offset];
    }
  }

  throw new Error('Terminating bit not found');
};

exports.readUInt32 = readUInt32;

var readUInt64 = function readUInt64(buffer, offset) {
  var result = BigInt(0);
  var index = offset;

  for (var shift = BigInt(0); shift < BigInt(64); shift += BigInt(7)) {
    if (index >= buffer.length) {
      throw new Error('Invalid buffer length');
    }

    var bit = BigInt(buffer[index]);
    index += 1;

    if (index === 10 + offset && bit > 0x01) {
      throw new Error('Value out of range of uint64');
    }

    result |= (bit & BigInt(rest)) << shift;

    if ((bit & BigInt(msg)) === BigInt(0)) {
      return [result, index - offset];
    }
  }

  throw new Error('Terminating bit not found');
};

exports.readUInt64 = readUInt64;

var readSInt32 = function readSInt32(buffer, offset) {
  var _exports$readUInt = exports.readUInt32(buffer, offset),
      _exports$readUInt2 = _slicedToArray(_exports$readUInt, 2),
      varInt = _exports$readUInt2[0],
      size = _exports$readUInt2[1];

  if (varInt % 2 === 0) {
    return [varInt / 2, size];
  }

  return [-(varInt + 1) / 2, size];
};

exports.readSInt32 = readSInt32;

var readSInt64 = function readSInt64(buffer, offset) {
  var _exports$readUInt3 = exports.readUInt64(buffer, offset),
      _exports$readUInt4 = _slicedToArray(_exports$readUInt3, 2),
      varInt = _exports$readUInt4[0],
      size = _exports$readUInt4[1];

  if (varInt % BigInt(2) === BigInt(0)) {
    return [varInt / BigInt(2), size];
  }

  return [-(varInt + BigInt(1)) / BigInt(2), size];
};

exports.readSInt64 = readSInt64;